/* eslint-disable max-len */
export type WorkingPeriod = {
  id: number
  year: number
  start_date: string
  end_date: string
  min_nights?: number
}

export type WorkingPeriodsReq = {
  year: number
  per_page: number
}

export type WorkingPeriodsRes = {
  count: number
  next: null | string
  previous: null | string
  total_pages: number
  results: WorkingPeriod[]
}

export const GET_WORKING_PERIODS_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/'

export const UPDATE_YEAR_MINIMUM_STAY_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/minimum_stay/'

export type CopyWorkingPeriodFromYearReq = {
  year: number
}

// KNM-92: ручка осталась только для копирования с прошлого года (передаётся { year }).
// Создание нового тарифа на год идёт через RatePlans.INIT_RATE_PLAN_URL.
export const INIT_WORKING_PERIODS_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/init/'

export type DeleteWorkingPeriodRes = WorkingPeriod[]

export const DELETE_WORKING_PERIOD_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/:period_id/'

export type UpdateWorkingPeriodReq = {
  start_date: string
  end_date: string
  min_nights?: number
}

export type UpdateWorkingPeriodRes = WorkingPeriod[]

export const UPDATE_WORKING_PERIOD_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/:period_id/'

export type AddWorkingPeriodReq = {
  border_date: string
  position: 'left' | 'right'
}

export type AddWorkingPeriodRes = WorkingPeriod[]

export const ADD_WORKING_PERIODS_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/:period_id/new_neighbor/'

export type SplitWorkingPeriodReq = {
  border_date: string
}

export type SplitWorkingPeriodRes = WorkingPeriod[]

export const SPLIT_WORKING_PERIODS_URL = '/v2/pms/accomodations/:accomodation_id/working_periods/:period_id/split/'

export type GetWorkingPeriodPricesReq = {
  year: number
}

export type GetWorkingPeriodPricesRes = {
  meal: 1 | 2 | 3 | 4 | 5 | 6
  cost_type: 1 | 2
  room_prices: {
    id: number
    type: number
    period: number
    price: number
  }[]
  room_extra_prices: {
    id: number
    type: number
    period: number
    price: number
  }[]
}
export const GET_WORKING_PERIODS_PRICES_URL = '/v2/pms/accomodations/:accomodation_id/room_categories/:accomodation_type/prices/'

export type UpdateWorkingPeriodPricesReq = {
  meal: 1 | 2 | 3 | 4 | 5 | 6
  cost_type: 1 | 2
  room_prices: {
    id: number
    price: number | null
  }[]
  room_extra_prices?: {
    id: number
    price: number | null
  }[]
}

export type UpdateWorkingPeriodPricesRes = {
  meal: 1 | 2 | 3 | 4 | 5 | 6
  cost_type: 1 | 2
  room_prices: {
    id: number
    type: number
    period: number
    price: number
  }[]
  room_extra_prices: {
    id: number
    type: number
    period: number
    price: number
  }[]
}
export const UPDATE_WORKING_PERIODS_PRICES_URL = '/v2/pms/accomodations/:accomodation_id/room_categories/:accomodation_type/prices/:year'
